import {EntitiesProperties} from "../../../utils/enums";
import {DynamicDatagrid, Grid, Paper, Typography, GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {ISupplyTagData} from "../../../interfaces/IOverviewData";

export interface ITagsTableProps {
    tagsData: ISupplyTagData[],
    loading: boolean,
    refreshFunc: () => void;
}
export const TagsTable = ({tagsData, loading, refreshFunc} : ITagsTableProps): JSX.Element => {
    const align = 'left'
    const {REQUESTS,COST,FILL_RATE,IMPRESSIONS, CPM} = EntitiesProperties.NUMERIC.ALL
    const columns: GridColDef[] = [
        {
            field: 'date',
            headerName: 'Date',
            type:'string',
            width: 150,
            renderCell: (params: GridRenderCellParams) => {
                return new Date(params.value).toLocaleDateString("he")
            },

        },
        {
            field: 'platform',
            headerName: 'Platform',
            width: 400,

            renderCell: (params: GridRenderCellParams) => {
                return params.value
            }


        },
        {
            field: 'tagId',
            headerName: 'Tag ID',
            width: 100,
            renderCell: (params: GridRenderCellParams) => {
                return params.value
            }
        },
        {
            field: COST,
            headerName: 'Cost',
            type: 'number',
            width: 100,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value.toLocaleString()
            }
        },
        {
            field: IMPRESSIONS,
            headerName: 'Impressions',
            type: 'number',
            width: 160,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value.toLocaleString()
            }
        },
        {
            field: REQUESTS,
            headerName: 'Requests',
            type: 'number',
            width: 180,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value?.toLocaleString()
            }
        },
        {
            field: FILL_RATE,
            headerName: 'Fill Rate',
            type: 'number',
            width: 160,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value
            }
        },
        {
            field: CPM,
            headerName: 'CPM',
            type: 'number',
            width: 90,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return params.value?.toFixed(2) || 0;
            }
        },
    ];


    function createRowData(item: any) {
        return {
            date: item.date,
            platform: item.platform,
            tagId: item.id,
            cost: item.cost,
            impressions: item.impressions ,
            requests: item.requests || 0,
            fillRate: item.fillRate || 0,
            cpm: item.cpm,
            id: item.index
        }
    }

    const tagsRows = tagsData?.map((row, index) => createRowData(row))
        .sort((a,b)=>b.cost-a.cost)
        .sort((a,b)=>new Date(b.date).getTime()-new Date(a.date).getTime())
        // .sort((a,b)=>b.cost-a.cost && b.date-a.date)

    return (
        <>
            <Grid container justifyContent={"space-around"}>
                <Grid size={12}>
                    <Typography variant={"overline"}>Supply Tags</Typography>
                    <Paper elevation={5} style={{borderRadius: "16px"}}>
                        <DynamicDatagrid rows={tagsRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );

}